import { jsx as _jsx } from "react/jsx-runtime";
import Item from "components/Emails/Item";
import UPDATE_EMAILS_TEMPLATES from "mutations/emails/updateEmailsTemplate";
import GET_EMAILS_TEMPLATE from "queries/emails/getEmailsTemplate";
import React from "react";
const TemplatesItem = () => (_jsx(Item, { getQuery: GET_EMAILS_TEMPLATE, getQueryDataName: "getEmailsTemplate", itemName: "template", updateMutation: UPDATE_EMAILS_TEMPLATES }));
export default TemplatesItem;
